import React, { useState } from "react";
import { FileText, FileSpreadsheet } from "lucide-react";
import LineItemsDoc from "../components/LineItemsDoc";
import { DOC_CONFIGS } from "../lib/docConfigs";
import { API } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Sales() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const open = (kind) => {
    const q = `token=${localStorage.getItem("token")}&month=${month}`;
    window.open(kind === "pdf" ? `${API}/pdf/sales-register?${q}` : `${API}/invoices/register/xlsx?${q}`, "_blank");
  };

  return (
    <div>
      <div className="mb-5 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div><h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-head">Sales</h1>
          <p className="text-sm text-slate-500 mt-0.5">Multi-item quotations, sales orders &amp; invoices · newest entries first</p></div>
        <div className="flex items-end gap-2 flex-wrap">
          <div>
            <span className="block text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-1">Invoice register</span>
            <Input data-testid="sales-register-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-40 bg-white h-9" />
          </div>
          <Button data-testid="sales-register-pdf" variant="outline" className="rounded-sm gap-1.5 h-9" onClick={() => open("pdf")}><FileText className="w-4 h-4" /> PDF</Button>
          <Button data-testid="sales-register-xlsx" className="bg-[#0B132B] hover:bg-[#1C2541] text-white rounded-sm gap-1.5 h-9" onClick={() => open("xlsx")}><FileSpreadsheet className="w-4 h-4" /> Excel</Button>
        </div>
      </div>
      <Tabs defaultValue="invoices">
        <TabsList className="bg-white border border-slate-200 rounded-sm mb-5">
          <TabsTrigger value="invoices" data-testid="sales-tab-invoices">Invoices</TabsTrigger>
          <TabsTrigger value="quotations" data-testid="sales-tab-quotations">Quotations</TabsTrigger>
          <TabsTrigger value="proforma" data-testid="sales-tab-proforma">Proforma Invoice</TabsTrigger>
          <TabsTrigger value="returns" data-testid="sales-tab-returns">Sales Returns</TabsTrigger>
        </TabsList>
        <TabsContent value="invoices"><LineItemsDoc config={DOC_CONFIGS.invoices} /></TabsContent>
        <TabsContent value="quotations"><LineItemsDoc config={DOC_CONFIGS.quotations} /></TabsContent>
        <TabsContent value="proforma">
          <p className="text-sm text-slate-500 mb-3">A Proforma Invoice is a pre-sale estimate — it does not reduce stock, does not add to customer outstanding and creates no GST or accounting entry. Convert it to a Sales Invoice when the order is confirmed.</p>
          <LineItemsDoc config={DOC_CONFIGS["proforma-invoices"]} />
        </TabsContent>
        <TabsContent value="returns">
          <p className="text-sm text-slate-500 mb-3">Record goods returned by a customer against an invoice. The return reduces revenue and profit for the return month, credits the customer's outstanding and puts the quantity back into stock.</p>
          <LineItemsDoc config={DOC_CONFIGS["sales-returns"]} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
